import NSS_Banner_Img from "../../../assets/CampuLifeImages/NSS_Banner_Img.jpg"
import nssactivity1 from "../../../assets/CampuLifeImages/nssactivity1.jpg"
import nssactivity2 from "../../../assets/CampuLifeImages/nssactivity2.jpg"
import nssactivity3 from "../../../assets/CampuLifeImages/nssactivity3.jpg"
import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage'
import nssactivity4 from "../../../assets/CampuLifeImages/nssactivity4.jpg"

const NSS = () => {

 
  const data = {
       name: "nss",
    pagename: "NSS",
    viewmore: true,
    viewless: true,
    title: "NSS Activities",
    contentImg: NSS_Banner_Img,
    para: "The National Service Scheme (NSS) is a Central Sector Scheme of Government of India, Ministry of Youth Affairs & Sports. The ideological orientation of NSS was inspired by the ideals of Mahatma Gandhi and started in 1969. “Education through Service” is the purpose of the NSS. It is a student-based volunteer program in India, aimed at fostering social responsibility and community service. It's a voluntary public service program where students can engage in various community development activities. NICAS has three NSS units 138,165, 203 each with 100 volunteers. These units provide an opportunity for those who want to serve the community around the institution. ",
    paracontinue: "NSS volunteers participate in regular social service activities like conducting Blood Donation Camps, Health Awareness Camps, Environmental Awareness Camps, Tree planting, creating awareness about the Clean India Campaign, Campus cleaning, the self-employment programme, and visiting and donating goods to nearby orphanages and mental health institutions.",
    hover: true,
    title1: "Vision : ",
    paranext: "The vision is to build the youth with the mind and spirit to serve the society and work for the social upliftment of the downtrodden masses of our nation.",
    title2: "Motto :",
    subtitle2: "“NOT ME BUT YOU”, reflects the value of democratic living and upholds the need for selfless service.",
    subtitle3: "Mission :",
    subtitlecontent3: "Personality development of the students through Community Service and Community Service through education.",
    fourhover: true
  }

  const hoverContent = [
    { img: nssactivity1, para1: "Clean Roads, Clear Future - Join Us in Keeping Our Streets Litter-Free ", para2: "September 23 2024" },
    { img: nssactivity2, para1: "Special Camp - Villukuri ", para2: "" },
    { img: nssactivity3, para1: "Blood Donation Camp", para2: "February 23, 2025" },
    { img: nssactivity4, para1: "Independence Day Celebration", para2: "March 14, 2024" }
  ]

  return (
    <>
      
      <ExtenStudClubGrievPage data = {data} hoverContent = {hoverContent}/>
      
    </>
    
  )
}

export default NSS